import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface AuditLog {
  id: string;
  userRole: string;
  action: string;
  details: Record<string, any>;
  ipAddress: string;
  deviceInfo: string;
  timestamp: number;
}

interface AdminState {
  gcpApiKey: string;
  logs: AuditLog[];
  setGcpApiKey: (key: string) => void;
  addLog: (log: Omit<AuditLog, 'id' | 'timestamp'>) => void;
  clearLogs: () => void;
}

export const useAdminStore = create<AdminState>()(
  persist(
    (set) => ({
      gcpApiKey: '',
      logs: [],
      setGcpApiKey: (key: string) => set({ gcpApiKey: key }),
      addLog: (log) =>
        set((state) => ({
          logs: [
            {
              ...log,
              id: crypto.randomUUID(),
              timestamp: Date.now(),
            },
            ...state.logs,
          ],
        })),
      clearLogs: () => set({ logs: [] }),
    }),
    {
      name: 'pdf-admin-storage',
    }
  )
);
